import { type IBaseAsyncSelectInputProps } from '@framework/form/inputs/AsyncSelectInput.tsx';
import { FrontCategoryAsyncSelectInput } from '../../../submission/filter/FrontCategoryAsyncSelectInput.tsx';

export interface IInquiryCategorySelectInputProps
  extends IBaseAsyncSelectInputProps {}

/**
 * Input per la selezione della categoria di una domanda.
 */
export function InquiryCategorySelectInput(
  props: IInquiryCategorySelectInputProps,
) {
  return <FrontCategoryAsyncSelectInput {...props} style={{ width: '100%' }} />;
}
